import { render, staticRenderFns } from "./ArtworkObsoleteMessage.vue?vue&type=template&id=7d8891d7"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports